"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "resolution": "Monthly",
    "metricType": "Percentage",
    "totalRecords": 14,
    "skip": 0,
    "take": 100,
    "recordsReturned": 14,
    "data": [
        {
            "date": "2021-01-31T00:00:00",
            "metric1": -0.157728,
            "metric2": 0.0
        },
        {
            "date": "2021-02-28T00:00:00",
            "metric1": 0.103755,
            "metric2": 0.0
        },
        {
            "date": "2021-03-31T00:00:00",
            "metric1": 0.076804,
            "metric2": 0.0
        },
        {
            "date": "2021-04-30T00:00:00",
            "metric1": 0.019872,
            "metric2": 0.0
        },
        {
            "date": "2021-05-31T00:00:00",
            "metric1": -0.001045,
            "metric2": 0.0
        },
        {
            "date": "2021-06-30T00:00:00",
            "metric1": -0.012532,
            "metric2": 0.0
        },
        {
            "date": "2021-07-31T00:00:00",
            "metric1": -0.059260,
            "metric2": 0.0
        },
        {
            "date": "2021-08-31T00:00:00",
            "metric1": 0.120523,
            "metric2": 0.0
        },
        {
            "date": "2021-09-30T00:00:00",
            "metric1": -0.048283,
            "metric2": 0.0
        },
        {
            "date": "2021-10-31T00:00:00",
            "metric1": 0.005396,
            "metric2": 0.0
        },
        {
            "date": "2021-11-30T00:00:00",
            "metric1": -0.041500,
            "metric2": 0.0
        },
        {
            "date": "2021-12-31T00:00:00",
            "metric1": -0.040072,
            "metric2": 0.0
        },
        {
            "date": "2022-01-31T00:00:00",
            "metric1": 0.000000,
            "metric2": 0.0
        },
        {
            "date": "2022-02-16T00:00:00",
            "metric1": 0.000000,
            "metric2": 0.0
        }
    ]
};
